var Version = (function () {
    function Version() {
        this.dcpVersion = '';
        this.componentsVersion = '';
        this.coreVersion = '';
    }
    return Version;
}());
export { Version };
